<template>
  <div>
    <div v-if="recurrenceData.isMeetingRecurrence">
      <span class="error--text">{{ meetingScheduleMessage }}</span>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            class="ml-4"
            x-small
            color="primaryDark"
            width="24"
            min-width="24"
            v-bind="attrs"
            v-on="on"
            @click="openRecurrenceDialog()"
          >
            <v-icon size="16" color="#fff"> mdi-pencil</v-icon>
          </a-btn>
        </template>
        <span>{{ $t("lblEditMeetingRec") }}</span>
      </v-tooltip>
      <v-tooltip v-if="isNewMeeting" bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            x-small
            color="secondary"
            v-on="on"
            v-bind="attrs"
            class="ml-2"
            @click="resetRecurrence()"
          >
            {{ $t("agenda.tipReset") }}
          </a-btn>
        </template>
        <span>{{ $t("lblResetMeetingRec") }}</span>
      </v-tooltip>
      <br v-if="recurrenceStartDateMessage" />
      <span class="error--text" v-if="recurrenceStartDateMessage">
        {{ recurrenceStartDateMessage }}</span
      >
      <br v-if="recurrenceStartTime" />
      <span class="error--text" v-if="recurrenceStartTime">
        {{ recurrenceTimeLable }}</span
      >
    </div>
    <v-tooltip bottom v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          small
          text
          color="primary"
          @click="openRecurrenceDialog()"
        >
          <v-icon small>mdi-plus</v-icon>{{ $t("lblAddMeetingRec") }}
        </v-btn>
      </template>
      <span> {{ $t("lblAddMeetingRectip") }} </span>
    </v-tooltip>
    <v-dialog
      v-if="show"
      v-model="show"
      scrollable
      persistent
      max-width="600px"
    >
      <v-card flat>
        <v-toolbar color="primaryLight1" dark height="50px">
          <span>{{ $t("agenda.hSetRecurrence") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <start-date
                v-model="recurrenceData.recurrenceStartDate"
                :label="startLable"
                :hasPastMeetings="hasPastMeetings"
                :isStartDate="true"
              ></start-date>
            </v-col>
            <v-col cols="12">
              <start-end-time
                :startDate.sync="recurrenceComputedStartTime"
                :endDate.sync="recurrenceComputedEndTime"
              ></start-end-time>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters align="center">
                <v-col cols="3" class="text-right mr-3">
                  {{ $t("lblRepeatEvery") }}:
                </v-col>
                <v-col cols="3" class="">
                  <repeat-every
                    v-model.number="recurrenceData.repeatInterval"
                    id="repeatEveryInput"
                    :suffix="monthLable"
                  ></repeat-every
                ></v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <on-the-day
                v-model="recurrenceData.recurrenceOnDay"
                :repeatType="recurrencePattern"
              ></on-the-day>
            </v-col>
            <v-col cols="12">
              <start-date
                v-model="recurrenceData.recurrenceEndDate"
                :isRemoveBtnShow="true"
                :label="endLable"
                :isValid="isEndDateTimeValid"
                @change="validateEndDate"
                :minEndDate="minEndDate"
              ></start-date>
            </v-col>
            <v-col cols="12" style="display: grid; justify-content: center">
              <v-row no-gutters align="center">
                <v-col cols="auto">
                  <span>{{ scheduleMessage }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="pageHeader"
                text
                @click="onSave()"
                >{{ $t("btnSave") }}</v-btn
              >
            </template>
            <span>{{ $t("btnSave") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="pageHeader"
                text
                @click="close()"
                >{{ $t("btnClose") }}</v-btn
              >
            </template>
            <span>{{ $t("btnClose") }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import StartDate from "./recurrence/StartDate.vue";
import RepeatEvery from "./recurrence/RepeatEvery.vue";
import OnTheDay from "./recurrence/OnTheDay.vue";
import WeekChips from "./recurrence/WeekChips.vue";
import RepeatTypeSelect from "./recurrence/RepeatTypeSelect.vue";
import { formatDate } from "@/utils/util";
import { cloneDeep } from "lodash";
import StartEndTime from "./recurrence/StartEndTime.vue";

Vue.use(DatePickerPlugin);
const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default {
  components: {
    StartDate,
    RepeatEvery,
    OnTheDay,
    WeekChips,
    RepeatTypeSelect,
    StartEndTime,
  },
  name: "MeetingRecurrenceSettings",
  props: {
    startDate: [String, Date],
    endDate: String,
    recurrenceFormData: Object,
    isNewMeeting: Boolean,
    hasPastMeetings: Boolean,
  },
  data() {
    return {
      recurrenceTimeLable: null,
      recurrenceStartTime: null,
      recurrenceStartDateMessage: null,
      recurrenceEndTime: null,
      isResetClick: false,
      isEndDateTimeValid: true,
      meetingScheduleMessage: "",
      cloneRecurrenceData: {},
      recurrenceData: {},
      selectedDays: [weekDays[new Date().getDay()]],
      endDateC: null,
      repeatDays: 1,
      scheduleMessage: "",
      waterMark: "Select a datetime",
      show: false,
      select: { text: "Monthly", value: "month" },
    };
  },
  mounted() {
    this.recurrenceData = cloneDeep(this.recurrenceFormData);
    this.getAllRecurrenceMessages();
    // this.meetingScheduleMessage = this.generateMonthlyRecurrenceMessage();
    this.recurrenceStartTime = cloneDeep(this.startDate);
    this.recurrenceEndTime = cloneDeep(this.endDate);
    // this.recurrenceTimeLable = this.getRecurrenceTimeLable();
  },
  computed: {
    monthLable() {
      return this.$t("lblMonth");
    },
    startLable() {
      return this.$t("search.startDate");
    },
    endLable() {
      return this.$t("search.endDate");
    },
    repeatInterval() {
      return this.recurrenceData.repeatInterval;
    },
    recurrencePattern() {
      return this.recurrenceData.recurrencePattern;
    },
    recurrenceOnDay() {
      return this.recurrenceData.recurrenceOnDay;
    },
    locale() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.locale !== "ja" ? "dd-MMM-yyyy" : "dd-MMM-yyyy HH:mm";
    },
    startDateTime() {
      return this.recurrenceData.recurrenceStartDate;
    },
    recurrenceEndDate() {
      return this.recurrenceData.recurrenceEndDate;
    },
    endDateTime() {
      return this.recurrenceData.recurrenceEndDate;
    },
    minEndDate() {
      return new Date(this.startDateTime);
    },
    recurrenceComputedStartTime: {
      get() {
        return new Date(this.recurrenceStartTime);
      },
      set(value) {
        this.recurrenceStartTime = new Date(value);
      },
    },
    recurrenceComputedEndTime: {
      get() {
        return new Date(this.recurrenceEndTime);
      },
      set(value) {
        this.recurrenceEndTime = new Date(value);
      },
    },
  },
  watch: {
    recurrenceFormData: {
      handler(newData) {
        this.recurrenceData = cloneDeep({ ...newData });
      },
      deep: true,
    },
    recurrenceData: {
      handler() {
        // this.scheduleMessage = this.generateMonthlyRecurrenceMessage();
        this.getAllRecurrenceMessages();
      },
      deep: true,
    },
    "recurrenceData.recurrenceStartDate": {
      immediate: true,
      async handler(newValue, oldValue) {
        if (
          newValue &&
          oldValue &&
          JSON.stringify(new Date(newValue)) !==
            JSON.stringify(new Date(oldValue))
        ) {
          const hh = new Date(this.recurrenceStartTime).getHours();
          const mm = new Date(this.recurrenceStartTime).getMinutes();

          let newDate = new Date(newValue);

          newDate.setHours(hh);
          newDate.setMinutes(mm);

          this.recurrenceStartTime = new Date(newDate).toISOString();
          if (
            new Date(this.recurrenceStartTime) >
            new Date(this.recurrenceEndTime)
          ) {
            this.recurrenceEndTime = AddMinutesToDate(
              new Date(this.recurrenceStartTime),
              120
            ).toISOString();
          }
        }
      },
    },
  },
  methods: {
    openRecurrenceDialog,
    close,
    onSave,
    generateSelectionMessage,
    formatDate,
    onRemoveEndDate,
    deleteRecurrence,
    validateEndDate,
    resetRecurrence,
    getStartEndTimeDetails,
    getRecurrenceTimeLable,
    generateMonthlyRecurrenceMessage,
    getRecurrenceStartDateMessage,
    getAllRecurrenceMessages,
  },
};

function AddMinutesToDate(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}

function getRecurrenceTimeLable() {
  return this.$t("agenda.lblRecurrenceTime", {
    time: this.getStartEndTimeDetails(
      this.recurrenceStartTime,
      this.recurrenceEndTime
    ),
  });
}

function getStartEndTimeDetails(startDateTime, endDateTime) {
  const Xmas95 = new Date(startDateTime);
  const endDate = new Date(endDateTime);
  const dateTemp = new Intl.DateTimeFormat(this.selectedLang, {
    dateStyle: "full",
    timeStyle: "long",
  }).format(Xmas95);
  const startDate = new Intl.DateTimeFormat(this.selectedLang, {
    dateStyle: "long",
  }).format(Xmas95);
  const startTime = new Intl.DateTimeFormat(this.selectedLang, {
    timeStyle: "short",
  }).format(Xmas95);
  const endTime = new Intl.DateTimeFormat(this.selectedLang, {
    timeStyle: "short",
  }).format(endDate);
  const d = Xmas95.getDate();
  const day = d < 10 ? `0${d}` : d;
  const m = Xmas95.getMonth() + 1; //Month from 0 to 11
  const month = m < 10 ? `0${m}` : m;
  const y = Xmas95.getFullYear();
  return `${startTime} - ${endTime}`;
}

function resetRecurrence() {
  this.isResetClick = true;
  this.isEndDateTimeValid = true;
  this.$emit("reset");
}

function validateEndDate(isValid) {
  if (!this.isResetClick) {
    this.isEndDateTimeValid = isValid;
  }
}

function onRemoveEndDate() {
  this.recurrenceEndDate = null;
}

function getAllRecurrenceMessages() {
  this.meetingScheduleMessage = this.generateMonthlyRecurrenceMessage();
  this.recurrenceTimeLable = this.getRecurrenceTimeLable();
  this.recurrenceStartDateMessage = this.getRecurrenceStartDateMessage();
}

function generateMonthlyRecurrenceMessage() {
  let message = "";
  const frequency =
    this.repeatInterval === 1
      ? `${this.$t("lblMonthOn")} `
      : `${this.repeatInterval} ${this.$t("lblMonthsOn")} `;
  const dayMessage =
    Number(this.recurrenceOnDay.selectedValue) === 0
      ? `${this.$t("lblDay")} ${this.recurrenceOnDay.day}`
      : `${this.recurrenceOnDay.selectedWeekSlot} ${capitalizeFLetter(
          this.recurrenceOnDay.selectedWeekDay
        )}`;
  message = `${this.$t("lblOccursEvery")} ${frequency}${dayMessage}`;
  return message;
}

function getRecurrenceStartDateMessage() {
  if (this.recurrenceData.recurrenceStartDate) {
    const startDate = this.formatDate(
      new Date(this.recurrenceData.recurrenceStartDate),
      "MM/dd/yyyy"
    );
    return ` ${this.$t("lblStarting")} ${startDate}`;
  }
}

function generateSelectionMessage() {
  let message = "";
  if (this.recurrencePattern === "day") {
    message =
      this.repeatInterval === 1
        ? this.$t("lblOccursEveryDay")
        : `${this.$t("lblOccursEvery")} ${this.repeatInterval} ${this.$t(
            "lblDays"
          )}`;
  } else if (this.recurrencePattern === "week") {
    message =
      this.repeatInterval === 1
        ? `${this.$t("lblOccursEvery")} ${this.selectedDays}`
        : `${this.$t("lblOccursEvery")} ${this.repeatInterval} ${this.$t(
            "lblWeeksOn"
          )} ${this.selectedDays}`;
  } else if (this.recurrencePattern === "month") {
    const frequency =
      this.repeatInterval === 1
        ? `${this.$t("lblMonthOn")} `
        : `${this.repeatInterval} ${this.$t("lblMonthsOn")} `;
    const dayMessage =
      Number(this.recurrenceOnDay.selectedValue) === 0
        ? `${this.$t("lblDay")} ${this.recurrenceOnDay.day}`
        : `${this.recurrenceOnDay.selectedWeekSlot} ${capitalizeFLetter(
            this.recurrenceOnDay.selectedWeekDay
          )}`;
    message = `${this.$t("lblOccursEvery")} ${frequency}${dayMessage}`;
  } else if (this.recurrencePattern === "year") {
    const frequency =
      Number(this.recurrenceOnDay.selectedValue) === 0
        ? ""
        : `${this.recurrenceOnDay.selectedWeekSlot} ${capitalizeFLetter(
            this.recurrenceOnDay.selectedWeekDay
          )} of `;
    message = `${this.$t("lblOccursEveryYearOn")} ${frequency}${
      monthNames[this.recurrenceOnDay.selectedMonth]
    }`;
  } else {
    message = `${this.$t("lblNotset")}`;
  }
  if (this.recurrenceData.recurrenceStartDate) {
    const startDate = this.formatDate(
      new Date(this.recurrenceData.recurrenceStartDate),
      "MM/dd/yyyy"
    );
    message += ` ${this.$t("lblStarting")} ${startDate}`;
  }
  if (this.recurrenceEndDate) {
    const endDate = this.formatDate(
      new Date(this.recurrenceEndDate),
      "MM/dd/yyyy"
    );
    message += ` ${this.$t("lblUntil")} ${endDate}`;
  }

  return message;
}

function capitalizeFLetter(string) {
  return string.replace(/^./, string[0].toUpperCase());
}

function deleteRecurrence() {
  const { recurrenceData } = this;
  recurrenceData.isMeetingRecurrence = false;
}

function openRecurrenceDialog() {
  // if (item.value === "weekday") {
  //   this.selectedDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
  //   this.recurrencePattern = "week";
  // } else {
  //   this.selectedDays = [weekDays[new Date().getDay()]];
  //   this.recurrencePattern = item.value;
  // }
  this.isEndDateTimeValid = true;
  this.isResetClick = false;
  this.selectedDays = [weekDays[new Date().getDay()]];
  this.recurrenceData.recurrencePattern = "month";

  this.recurrenceStartTime = cloneDeep(this.startDate);
  this.recurrenceEndTime = cloneDeep(this.endDate);
  if (this.isNewMeeting && new Date(this.startDate) >= new Date()) {
    this.recurrenceData.recurrenceStartDate = this.startDate;
  }
  this.cloneRecurrenceData = cloneDeep(this.recurrenceData);
  this.show = true;
}

function close() {
  this.show = false;
  this.isEndDateTimeValid = true;
  this.recurrenceData = this.cloneRecurrenceData;
}

function onSave() {
  const { recurrenceData, getAllRecurrenceMessages } = this;
  if (!recurrenceData.recurrenceEndDate) {
    this.isEndDateTimeValid = false;
    return false;
  }
  recurrenceData.isMeetingRecurrence = true;
  updateRecurrenceData(recurrenceData);
  this.$emit("update:recurrenceFormData", recurrenceData);
  const timeData = {
    startTimeDate: this.recurrenceStartTime,
    endTimeDate: this.recurrenceEndTime,
  };
  this.$emit("updateStartEndTime", timeData);
  this.show = false;
  getAllRecurrenceMessages();
  // this.meetingScheduleMessage = generateMonthlyRecurrenceMessage();
  // this.recurrenceTimeLable = this.getRecurrenceTimeLable();
}

function updateRecurrenceData(recurrenceData) {
  if (recurrenceData.recurrenceOnDay.selectedValue === 0) {
    recurrenceData.recurrenceOnDay.selectedWeekSlot = "first";
    recurrenceData.recurrenceOnDay.selectedWeekDay = "sunday";
    recurrenceData.recurrenceOnDay.selectedMonth = new Date().getMonth();
  } else {
    recurrenceData.recurrenceOnDay.day = new Date().getDate();
  }
}
</script>

<style scoped>
::v-deep .e-date-wrapper {
  border: 1px solid gray !important;
  border-radius: 4px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  height: 40px;
  font-size: 15px !important;
}

::v-deep .e-date-wrapper .e-input-group-icon {
  min-height: 18px !important;
  min-width: 18px !important;
}
</style>